import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import * as $ from 'jquery';

@Component({
  selector: 'app-cpp-marketing-program-grid-view',
  templateUrl: './cpp-marketing-program-grid-view.component.html',
  styleUrls: ['./cpp-marketing-program-grid-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppMarketingProgramGridViewComponent implements OnInit {

  @ViewChild('marketingProgramPaginator', { read: MatPaginator }) marketingProgramPaginator: MatPaginator;

  marketingProgramDataSourceChild: MatTableDataSource<any>;
  @Output() toggleFavoriteItems = new EventEmitter<any>();
  @Output() downloadProgramFile = new EventEmitter<any>();

  private _marketingProgramDataSource: any[] = [];

  @Input() set marketingProgramDataSource(value: any[]) {
    this._marketingProgramDataSource = value;
    this.marketingProgramDataSourceChild = new MatTableDataSource(this._marketingProgramDataSource);
    this.marketingProgramDataSourceChild.paginator = this.marketingProgramPaginator;
    // Ensure paginator is set before calling firstPage()
    if (this.marketingProgramDataSourceChild.paginator) {
      this.marketingProgramDataSourceChild.paginator.firstPage();
    }
  }

  get marketingProgramDataSource(): any[] {
    return this._marketingProgramDataSource;
  }

  // Table Columns
  programColumns: string[] = [
    'manufacturer',
    'program',
    'orderPeriod',
    'shipPeriod',
    'incentive',
    'notes',
    'product'
  ];


  toggleFavoriteItem(itemID: number) {
    this.toggleFavoriteItems.emit(itemID);
  }

  ngOnInit(): void {
  }

  @HostListener('window:resize', ['$event'])
  onresize(event) {
    this.setHeight();
  }

  ngAfterViewInit() {
    this.setHeight();
  }

  /**
   * Sets the height of the template.
   */
  setHeight() {
    const templateHeight = window.innerHeight - $('.order-top-sec').outerHeight() - 220;
    $('.dealertableContainer').css('max-height', templateHeight + 'px');
  }

  downloadFile(mediaObjectId) {
    this.downloadProgramFile.emit(mediaObjectId);
  }

}
